<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: 'welcome-category-list', params: {save: true}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        <strong>{{ funcType }}</strong> 分类
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="名称" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name" required />
        </b-form-group>
        <b-form-group label="代号" label-for="code">
          <b-form-input id="code" type="text" v-model="data.code" :disabled="update" required />
        </b-form-group>
        <b-form-group label="图标" label-for="icon">
          <b-form-input id="icon" type="text" v-model="data.icon" />
        </b-form-group>
        <b-form-group label="排位" label-for="icon">
          <b-form-input id="sortId" type="number" v-model="data.sortId" min="1" required />
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat" /> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'

export default {
  name: 'welcome-category-form',
  mixins: [Error],
  props: ['formData', 'func', 'isUpdate'],
  data () {
    return {
      data: this.formData,
      staticData: JSON.parse(JSON.stringify(this.formData)),
      funcType: this.func,
      update: this.isUpdate
    }
  },
  created () {},
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      if (this.update) {
        this.$emit('submitData', this.handleUpdateData())
      } else {
        this.$emit('submitData', this.data)
      }
    },
    onReset (evt) {
      evt.preventDefault()
      this.data = JSON.parse(JSON.stringify(this.staticData))
    },
    handleUpdateData () {
      return {
        name: this.data.name,
        icon: this.data.icon,
        sortId: this.data.sortId
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CategoryForm.vue?0f4e3fff